import { IFundsOriginListResponse } from '../common/interfaces'
import { apiUrl } from '../config/api'

export const FundsOriginService = () => {
  const list = () =>
    apiUrl.get('funds-origin/list').then((res) => res.data as IFundsOriginListResponse)

  return {
    list,
  }
}
